import { CreateLogger } from "@swivl-mono/helpers";
import { Log } from "@swivl-mono/types";

import SocketEventsManager from "../SocketEvents.Manager";

const log = CreateLogger(Log.NOTIFICATIONS, "lifeccyle");

export function AttachLifecycleEvents() {
  if (SocketEventsManager.lifecycleListenersAttached) return;

  // Page visibility (backgrounded tabs often throttle timers/websockets)
  const onVisibility = () => {
    const prev = SocketEventsManager.visibility;
    SocketEventsManager.visibility = document.visibilityState;
    log("info", "lifecycle", "visibilitychange", { from: prev, to: SocketEventsManager.visibility });
    if (SocketEventsManager.visibility === "hidden") {
      SocketEventsManager.wentInvisibleAt = Date.now();
      log("Setting invisible at :", SocketEventsManager.wentInvisibleAt);
    } else {
      // check if it was hidden for a long time (10s)
      const shouldResync = SocketEventsManager.wentInvisibleAt && Date.now() - SocketEventsManager.wentInvisibleAt > 10_000;
      if (shouldResync) {
        // If hidden for a long time, do a full resync
        SocketEventsManager.runResync();
      }
      log("Setting visible at :", shouldResync);

      SocketEventsManager.wentInvisibleAt = undefined;
    }
    // You can choose to proactively ping or fetch cursors when visible again.
    if (SocketEventsManager.visibility === "visible") {
      // If socket thinks it's connected but was actually “half-open”, force a ping
      SocketEventsManager.safePing();
    }
  };

  // Page lifecycle: pagehide/pageshow cover bfcache and tab switching
  const onPageHide = (e: PageTransitionEvent) => {
    log("debug", "lifecycle", "pagehide", { persisted: e.persisted });
  };
  const onPageShow = (e: PageTransitionEvent) => {
    log("debug", "lifecycle", "pageshow", { persisted: e.persisted });
    SocketEventsManager.safePing();
  };

  // Experimental freeze/resume (Chrome)
  // @ts-ignore
  const onFreeze = () => log("debug", "lifecycle", "freeze");
  // @ts-ignore
  const onResume = () => {
    log("debug", "lifecycle", "resume");
    SocketEventsManager.safePing();
  };

  const onOnline = () => {
    log("info", "network", "online");
    SocketEventsManager.tryReconnect();
  };
  const onOffline = () => log("warn", "network", "offline");

  const onConnectionChange = () => {
    // @ts-ignore
    const info = navigator.connection;
    log(
      "debug",
      "network",
      "connection_change",
      info
        ? {
            effectiveType: info.effectiveType,
            downlink: info.downlink,
            rtt: info.rtt,
            saveData: info.saveData
          }
        : { supported: false }
    );
    SocketEventsManager.safePing();
  };

  document.addEventListener("visibilitychange", onVisibility);
  window.addEventListener("pagehide", onPageHide);
  window.addEventListener("pageshow", onPageShow);
  // @ts-ignore
  window.addEventListener?.("freeze", onFreeze);
  // @ts-ignore
  window.addEventListener?.("resume", onResume);
  window.addEventListener("online", onOnline);
  window.addEventListener("offline", onOffline);
  // @ts-ignore
  navigator.connection?.addEventListener?.("change", onConnectionChange);

  SocketEventsManager.lifecycleListenersAttached = true;
}
